import axios from "axios";
import { LtlPipelineViewModel } from "../../../../../../ViewModel/LtlPipelineViewModel";
import { ProjectViewModel } from "../../../../../../ViewModel/ProjectViewModel";
import { LtlRoutingRouteViewModel } from "../../../../../../ViewModel/LtlRoutingRouteViewModel";
import { GetQueryString } from "../../../../../../../Utils/GetQueryString";
import { getQuery } from "./GetQuery";

export default async (
  project: ProjectViewModel,
  ltlPipeline: LtlPipelineViewModel,
  baseUrl: string
) => {
  const query = getQuery(project, ltlPipeline);

  const url = `${baseUrl}?${GetQueryString(query)}`;
  const response = await axios.get(url);

  return response.data as Array<LtlRoutingRouteViewModel>;
};
